import { render } from "./AiSolutions.vue?vue&type=template&id=170dd22c&scoped=true"
import script from "./AiSolutions.vue?vue&type=script&lang=js"
export * from "./AiSolutions.vue?vue&type=script&lang=js"

import "./AiSolutions.vue?vue&type=style&index=0&id=170dd22c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170dd22c"]])

export default __exports__